module.exports = __webpack_public_path__ + "static/mobile-manager2-7c40516bae25670051b1ece711c45291.png";